import { observable, action, computed } from "mobx";

export default class CompareWithStore {

  @observable
  compareWithModalVisibilityMap = observable.map(
    {
      "da": false,
      "po": false,
      "mao": false,
    }
  );
  @observable compareWithModalTitle = "";
  @observable branchIndex = 0;

  @observable selectedItemForComparisonAgainstProduction = {};
  @observable selectedItemForComparisonAgainstMaster = {};
  @observable selectedItemForComparisonAgainstFinalRelease = {};
  @observable selectedItemForComparisonAgainstOtherBranch = {};

  @action
  compareWithProduction = (parent, item) => {
    this.selectedItemForComparisonAgainstProduction = item;
    this.compareWithModalTitle = "Differences to Production";
    this.toggleCompareWithModalVisibility(parent);
  }

  @action
  compareWithMaster = (parent, item) => {
    this.selectedItemForComparisonAgainstMaster = item;
    this.compareWithModalTitle = "Differences to Master";
    this.toggleCompareWithModalVisibility(parent);
  }

  @action
  compareWithFinalRelease = (parent, item) => {
    this.selectedItemForComparisonAgainstFinalRelease = item;
    this.compareWithModalTitle = "Differences to Final Release";
    this.toggleCompareWithModalVisibility(parent);
  }

  @action
  compareWithOtherBranch = (parent, item, branchIndex) => {
    this.selectedItemForComparisonAgainstOtherBranch = item;
    this.branchIndex = branchIndex;
    this.compareWithModalTitle = "Differences to Other Branch";
    this.toggleCompareWithModalVisibility(parent);
  }

  @action
  toggleCompareWithModalVisibility = (parent) => {
    this.compareWithModalVisibilityMap.set(
      parent, !this.compareWithModalVisibilityMap.get(parent)
    );
  };

  isCompareWithModalVisible = (parent) => {
    return computed(() => this.compareWithModalVisibilityMap.get(parent)).get();
  }

  @computed
  get getSelectedItemForComparisonAgainstProduction() {
    return this.selectedItemForComparisonAgainstProduction;
  }

  @computed
  get getSelectedItemForComparisonAgainstMaster() {
    return this.selectedItemForComparisonAgainstMaster;
  }

  @computed
  get getSelectedItemForComparisonAgainstFinalRelease() {
    return this.selectedItemForComparisonAgainstFinalRelease;
  }

  @computed
  get getSelectedItemForComparisonAgainstOtherBranch() {
    return this.selectedItemForComparisonAgainstOtherBranch;
  }

  @computed
  get getCompareWithModalTitle() {
    return this.compareWithModalTitle;
  }

  @computed
  get getBranchIndex() {
    return this.branchIndex;
  }
}
